import { type ExportFormat } from './photoSlot';

/** JPG / PNG export-format toggle shared by the composers. */
export function FormatToggle({ value, onChange }: { value: ExportFormat; onChange: (f: ExportFormat) => void }) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-muted-foreground">Format</span>
      <div className="inline-flex rounded-md border border-input p-0.5">
        {(['jpeg', 'png'] as ExportFormat[]).map((f) => (
          <button
            key={f}
            type="button"
            onClick={() => onChange(f)}
            className={`rounded px-2.5 py-0.5 text-xs uppercase transition-colors ${
              value === f ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            {f === 'jpeg' ? 'JPG' : 'PNG'}
          </button>
        ))}
      </div>
      <span className="text-[11px] text-muted-foreground">
        {value === 'jpeg' ? 'smaller, best for IG/SC' : 'lossless, larger'}
      </span>
    </div>
  );
}
